var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owal-progress-bar__container"},[_c('div',{staticClass:"owal-progress-bar__progress-outer"},[_c('div',{staticClass:"owal-progress-bar__progress-inner",style:(`width: ${this.percentComplete * 100.0}%`)},[_vm._v(" ... ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }